export enum AttributePaginationFormatEnum {
  STATUS = 'status',
  VIEW = 'view',
  DATE = 'date',
  DATE_DD_MM_YYYY = 'date::dd-MM-yyyy',
  DATE_DD_MM_YYYY_H_MM_S = 'date::dd-MM-yyyy HH:mm:ss',
  DATE_D_EEEE_H_MM = 'date::d, EEEE H:mm',
  LOCALIZED = 'localized',
  LOCALIZED_TEXTAREA = 'localizedTextarea',
  TEXTAREA = 'textarea',
  STRING = 'string',
  NUMBER = 'number',
  BOOLEAN = 'boolean',
  SELECT = 'select',
  CURRENCY = 'currency',
  ACCORDION = 'accordion',
  TAGS = 'tags',
  PASSWORD = 'password',
  IMAGE = 'image',
  ADDRESS = 'address',
  COLOR = 'color',
  BARCODE_TYPE = 'barcodeType',
  BROADCAST_MESSAGE_STATUS = 'broadcast-message-status',
  CUSTOM = 'custom',
  STRING_DATE = 'stringDate'
}
